import { getAdditionalUserInfo, getRedirectResult } from "firebase/auth";
import { History, Location } from "history";
import { NavigateFunction } from "react-router-dom-v5-compat";

import { Dispatch, GetState } from "common/types";

import { getFirebaseAuth } from "services/firebase/auth";

import { getRegion, signInStart } from "seneca-common/features/user/state";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import { makeSignUpUserDetailsLink } from "features/sign-up/common-routes/links";
import {
  makeInternalLink,
  pathEndings
} from "features/sign-up/global-sign-up-modal/utils";

import { proceedUserSignIn, proceedUserSignUp } from "./utils";
import extractUserDetailsWithLinkedProviders from "./utils/extractUserDetailsWithLinkedProviders";

export default function signInWithProviderWithRedirect(
  location: Location<any>,
  navigate: NavigateFunction
) {
  const onSignUpSuccess = () => {
    const { state, ...link } = makeInternalRedirectState({
      pathname: makeSignUpUserDetailsLink("/sign-up"),
      state: location.state
    } as any);
    navigate(link, { state });
  };

  return async function (dispatch: Dispatch, getState: GetState) {
    getRedirectResult(getFirebaseAuth())
      .then(async authInfo => {
        if (authInfo) {
          const firebaseUserInfo = getAdditionalUserInfo(authInfo);
          if (firebaseUserInfo) {
            dispatch(signInStart());

            const region = getRegion(getState())!;

            if (firebaseUserInfo.isNewUser) {
              const userDetails = extractUserDetailsWithLinkedProviders({
                authInfo,
                firebaseUserInfo
              });

              await dispatch(
                proceedUserSignUp({
                  userInfoToSave: userDetails,
                  region,
                  onSignUpSuccess
                })
              );
            } else {
              await dispatch(
                proceedUserSignIn({
                  region,
                  userId: authInfo.user.uid
                })
              );
            }
          }
        }
      })
      .catch(err => {
        if (err.code === "auth/account-exists-with-different-credential") {
          const { state, ...link } = makeInternalRedirectState({
            pathname: makeInternalLink(pathEndings.confirmPassword),
            state: {
              ...location.state,
              auth: {
                credential: err.credential.toJSON(),
                email: err.email
              }
            }
          } as any);
          navigate(link, { state });
        }
      });
  };
}
